import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Shared neo-brutalist input chrome — hint state keeps border + offset shadow in sync */
export function fieldChrome(hasHint: boolean, extra?: string, options?: { nested?: boolean }) {
  const nested = options?.nested ?? false
  return cn(
    "rounded-xl border-2 bg-white focus-visible:ring-0 transition-all dark:bg-zinc-900 dark:shadow-none",
    hasHint
      ? nested
        ? "border-amber-400 focus-visible:border-amber-500 dark:border-amber-500 dark:focus-visible:border-amber-400 shadow-none"
        : "border-amber-400 shadow-[2px_2px_0px_0px_rgba(245,158,11,0.95)] focus-visible:border-amber-500 dark:border-amber-500 dark:focus-visible:border-amber-400"
      : nested
        ? "border-black shadow-none focus-visible:border-black dark:border-white/20 dark:focus-visible:border-white"
        : "border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] focus-visible:border-black dark:border-white/20 dark:focus-visible:border-white",
    extra,
  )
}
